"use client"

import Link from "next/link"
import { useState, useEffect } from "react"

interface DiscountProps {
  lang: string
}

const DiscountOfferTrip: React.FC<DiscountProps> = ({ lang }) => {
  const [translations, setTranslations] = useState<any>(null)

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const response = await fetch(`/api/translations/${lang}`)
        const data = await response.json()
        setTranslations(data)
      } catch (error) {
        console.error("Failed to fetch translations:", error)
      }
    }
    fetchTranslations()
  }, [lang])

  if (!translations) {
    return null
  }

  return (
    <>
      <div className="discount-area bg-color-f3f4f6 pt-175 pb-150">
        <div className="container">
          <div className="section-title">
            <span className="top-title">
              {translations.app?.discount?.title || "Descubre Nuestro Paraíso"}
            </span>
            <h2>
              {translations.app?.discount?.subtitle ||
                "Un vistazo a la belleza y comodidad"}
            </h2>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-6">
              <Link
                href="/playa"
                className="discount-single-item text-decoration-none d-block"
                style={{
                  backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_245,f-auto,q_auto/SAM_7710_a9lw67_W_MAIVd8A )`,
                  height: "245px",
                }}
              >
                <div className="discount-single-content">
                  <h3>
                    {translations.app?.discount?.group1?.title || "El Yukayeke"}
                  </h3>
                  <span>
                    {translations.app?.discount?.group1?.subtitle ||
                      "Alquiler de la villa"}
                  </span>
                </div>
              </Link>

              <Link
                href="/kaney"
                className="discount-single-item text-decoration-none d-block"
                style={{
                  backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_245,f-auto,q_auto/SAM_7774_t8jnf2_z3Rou87wo )`,
                  height: "245px",
                }}
              >
                <div className="discount-single-content">
                  <h3>
                    {translations.app?.discount?.group2?.title || "El Kaney"}
                  </h3>
                  <span>
                    {translations.app?.discount?.group2?.subtitle ||
                      "Para actividades"}
                  </span>
                </div>
              </Link>
            </div>

            <div className="col-lg-4 col-md-6">
              <Link
                href="/piscina"
                className="discount-single-item text-decoration-none d-block"
                style={{
                  backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_516,f-auto,q_auto/PXL_20240512_191842614_2_mxssyy_ChUT7D7WW )`,
                  height: "516px",
                }}
              >
                <div className="discount-single-content">
                  <h3>
                    {translations.app?.discount?.group3?.title || "Piscina"}
                  </h3>
                  <span>
                    {translations.app?.discount?.group3.subtitle ||
                      "Semi-olímpica"}
                  </span>
                </div>
              </Link>
            </div>

            <div className="col-lg-5 col-md-12">
              <Link
                href="/abajo"
                className="discount-single-item text-decoration-none d-block"
                style={{
                  backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_245,f-auto,q_auto/PXL_20240508_180945006.MP_2_py4n5d_lLjPMCD2w)`,
                  height: "245px",
                }}
              >
                <div className="discount-single-content">
                  <h3>
                    {translations.app?.discount?.group4?.title ||
                      "Cuartos abajo"}
                  </h3>
                  <span>
                    {translations.app?.discount?.group4?.subtitle ||
                      "Para 4 personas con balcón"}
                  </span>
                </div>
              </Link>

              <div className="row">
                <div className="col-lg-5 col-md-6 mb-4 mb-lg-0">
                  <Link
                    href="/studio"
                    className="discount-single-item text-decoration-none d-block mb-0"
                    style={{
                      backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_245,f-auto,q_auto/PXL_20240508_181741458.MP_2_qva9hs_m_bjHcI53 )`,
                      height: "245px",
                    }}
                  >
                    <div className="discount-single-content">
                      <h3>
                        {translations.app?.discount?.group5?.title || "Studio"}
                      </h3>
                      <span>
                        {translations.app?.discount?.group5?.subtitle ||
                          "Cuartos para 2 con cocina"}
                      </span>
                    </div>
                  </Link>
                </div>

                <div className="col-lg-7 col-md-6 mb-4 mb-lg-0">
                  <Link
                    href="/arriba"
                    className="discount-single-item objeit-fit-cover mb-0 text-decoration-none d-block"
                    style={{
                      backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_245,f-auto,q_auto/PXL_20240508_181352240.MP_2_ultmga_o27-ez2W9 )`,
                      height: "245px",
                    }}
                  >
                    <div className="discount-single-content">
                      <h3>
                        {translations.app?.discount?.group6?.title ||
                          "Cuartos arriba"}
                      </h3>
                      <span>
                        {translations.app?.discount?.group6?.subtitle ||
                          "Para 4 personas"}
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DiscountOfferTrip
